module.exports = __webpack_public_path__ + "static/media/user.a96d82ba.svg";